import { FC, useEffect } from "react";
import { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";

import "react-date-range/dist/theme/default.css";
import "react-date-range/dist/styles.css";

interface IRangeDatePickerProps {
  date: any;
  position?: string;
  dateInputValues: any;
  isCountCalendar: number;
  setDate: (date: any) => void;
  setDateInputValues: (date: any) => void;
}

const CustomDateInput: FC<IRangeDatePickerProps> = ({
  setDateInputValues,
  dateInputValues,
  isCountCalendar,
  setDate,
  date
}) => {

  useEffect(() => {
    registerLocale("ru", ru);
  }, []);

  const handleChangeInputValues = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const inputElement = e.target;
    const name = inputElement.name;
    const value = inputElement.value;

    let formattedValue = value;
    let newDate: Date | null = new Date();
    const cursorPosition = e.currentTarget.selectionStart || 0;

    if (!formattedValue.includes('/')) {
      if (value.length > 2 && value.length <= 4) {
        formattedValue = `${value.slice(0, 2)}/${value.slice(2)}`;
      } else if (value.length > 4) {
        formattedValue = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
      }
    }

    const valueList = formattedValue.split("/");

    if (Number(valueList[0]) > 31) {
      const newValue = '01' + value.slice(2);
      inputElement.value = newValue;
      inputElement.setSelectionRange(2, 2);
    } else if (valueList[0] === '00') {
      const newValue = '01' + value.slice(2);
      inputElement.value = newValue;
      inputElement.setSelectionRange(cursorPosition, cursorPosition);
    } else if (Number(valueList[1]) > 12) {
      const newValue = value.slice(0, 2) + '/12' + value.slice(5);
      inputElement.value = newValue;
      inputElement.setSelectionRange(5, 5);
    } else if (valueList[1] === '00') {
      const newValue = value.slice(0, 2) + '/01' + value.slice(5);
      inputElement.value = newValue;
      inputElement.setSelectionRange(cursorPosition, cursorPosition);
    } else if (Number(valueList[2]) < 1) {
      const newValue = value.slice(0, 6) + new Date().getFullYear();
      inputElement.value = newValue;
      inputElement.setSelectionRange(cursorPosition, cursorPosition);
    }

    const dayValue = Number(valueList[0]) < 32 && valueList[0] !== '00' ? valueList[0] : '01';
    const monthValue = Number(valueList[1]) > 12 ? '12' : valueList[1] === '00' ? '01' : valueList[1];
    const year = Number(valueList[2]) < 1 ? new Date().getFullYear() : valueList[2];

    formattedValue = dayValue ? `${dayValue && dayValue}${monthValue ? '/' + monthValue : ''}${year ? '/' + year : ''}` : '';

    if (dayValue && monthValue && year) {
      newDate = new Date(Number(year), Number(monthValue) - 1, Number(dayValue));
    }

    if (value !== '') {

      if (newDate && !isNaN(newDate.getTime())) {
        if (name === 'fromDate') {
          setDateInputValues([formattedValue, dateInputValues[1]]);
          const [day, month, year] = dateInputValues[1].split('/').map(Number);
          const updatedDates = [newDate, new Date(year, month - 1, day)];
          setDate(updatedDates.sort((a: any, b: any) => a - b));
        } else {
          setDateInputValues([dateInputValues[0], formattedValue]);
          const [day, month, year] = dateInputValues[0].split('/').map(Number);
          const updatedDates = [new Date(year, month - 1, day), newDate];
          setDate(updatedDates.sort((a: any, b: any) => a - b));
        }
      }
    } else {
      if (name === 'fromDate') {
        setDateInputValues(['', dateInputValues[1]]);
        setDate([new Date(), date[1]]);
      } else {
        setDateInputValues([dateInputValues[0], '']);
        setDate([date[0], new Date()])
      }
    }
  };

  const onKeypressHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputElement = e.currentTarget;
    const value = inputElement.value;
    let start = inputElement.selectionStart || 0;
    let end = inputElement.selectionEnd || 0;

    if (value.length > 10) {
      return
    }

    if (value) {
      e.preventDefault();
      if (e.key === 'Backspace') {
        if (start === 0) return;
        if (value[start - 1] !== '/') {
          const newValue = value.slice(0, start - 1) + '0' + value.slice(start);
          inputElement.value = newValue;
        }
        inputElement.selectionStart = start - 1;
        inputElement.selectionEnd = end - 1;
      }
      if (e.key === 'Delete') {
        if (start > 9) return;

        if (value[start] !== '/') {
          const newValue = value.slice(0, start) + '0' + value.slice(start + 1);
          inputElement.value = newValue;
        }
        inputElement.selectionStart = start + 1;
        inputElement.selectionEnd = start + 1;
      }
      if (e.key === '/') {
        inputElement.selectionStart = start + 1;
      }
      if (e.key >= '0' && e.key <= '9' && value.length === 10) {
        if (value[start] !== '/') {
          const newValue = value.slice(0, start) + e.key + value.slice(start + 1);
          inputElement.value = newValue;
        }

        e.currentTarget.selectionStart = start + 1;
        e.currentTarget.selectionEnd = end + 1;

        if (e.currentTarget.value[e.currentTarget.selectionStart] === '/') {
          e.currentTarget.selectionStart += 1;
          e.currentTarget.selectionEnd += 1;
        }
      } else if (e.key === 'ArrowLeft') {
        if (start > 0) {
          inputElement.selectionStart = start - 1;
          inputElement.selectionEnd = end - 1;
        }
      } else if (e.key === 'ArrowRight') {
        inputElement.selectionStart = start + 1;
        inputElement.selectionEnd = end + 1;
      }
    }

    handleChangeInputValues(e as unknown as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="calendar__inputs" style={{ flexDirection: `${isCountCalendar === 1 ? 'column' : 'row'}` }}>
      <input
        type="text"
        placeholder="От"
        name="fromDate"
        value={dateInputValues[0]}
        onChange={handleChangeInputValues}
        maxLength={10}
        onKeyDown={onKeypressHandler}
      />
      <input
        type="text"
        placeholder="До"
        name="toDate"
        value={dateInputValues[1]}
        onChange={handleChangeInputValues}
        maxLength={10}
        onKeyDown={onKeypressHandler}
      />
    </div>
  );
};

export default CustomDateInput;
